// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: rgba(16, 16, 17, 1);
    color: #fff;
    height: var(--menuBarHeight);
    padding: 0 100px;
    align-items: center;
    box-sizing: border-box;
    z-index: 100;
}

.noburger {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 10px;
    padding: 0 50px;
}

.yesburger {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 min(5%, 30px);
    font-size: 16px;
}

.menu-logo, .menu-logo-hamburger {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    color: #fff;
    text-decoration: none;
    font-family: var(--paragraphFont);
    font-weight: 700;
}
.menu-logo {
    font-size: 24px;
}
.menu-logo-hamburger {
    font-size: calc(var(--menuBarHeight) * 0.4);
}
.menu-logo:hover, .menu-logo-hamburger:hover {
    text-decoration: none;
}

.menu-logo-img, .menu-logo-img-hamburger {
    height: 1.2em;
    width: auto;
    margin-right: 0.2em;
    transition: 0.2s;
}
.menu-logo:hover .menu-logo-img, .menu-logo-hamburger:hover .menu-logo-img-hamburger {
    filter: brightness(1.2) saturate(1.05) contrast(1.1);
}

.menu-logo-locdescriptor {
    color: #fff;
    font-size: 18px;
    font-weight: 400;
    border-left: 1px solid #fffb;
    padding-left: 0.5em;
    margin-left: 0.5em;
}
.menu-logo-locdescriptor-burger {
    color: #fff;
    font-size: calc(var(--menuBarHeight) * 0.3);
    font-weight: 400;
    border-left: 1px solid #fffb;
    padding-left: 0.5em;
    margin-left: 0.5em;
}

@media screen and (max-width: 350px) {
    .menu-logo-vanishable-name {
        display: none;
    }
    .menu-logo-img-hamburger{
        margin-right: 0;
    }
    .menu-logo-locdescriptor-burger {
        font-size: calc(var(--menuBarHeight) * 0.25);
    }
}

.menu-middle {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
    flex-direction: row;
}

.menu-link {
    font-size: 16px;
    font-weight: 500;
    font-family: var(--paragraphFont);
    color: #fff;
    text-decoration: none;
    position: relative;
}
.menu-link:hover {
    text-decoration: none;
}

.menu-link-indev {
    font-size: 16px;
    font-weight: 500;
    font-family: var(--paragraphFont);
    color: #fff8;
    text-decoration: none;
    position: relative;
    cursor: default;
}

/* Box that appears on hovering over indev link */
.menu-link-indev-hoverdesc {
    position: absolute;
    top: calc(100% + 5px);
    left: 50%;
    transform: translateX(-50%);
    width: max-content;
    background-color: #fff;
    color: #000;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 700;
    font-family: var(--paragraphFont);
    opacity: 0;
    pointer-events: none;
    transition: 0.2s;
    box-shadow: -1px 1px 10px 4px #8888;
    z-index: 1005;
}
.menu-link-indev:hover .menu-link-indev-hoverdesc {
    opacity: 1;
    pointer-events: all;
}

.menu-right {
    display: flex;
    align-items: center;
    margin-left: auto;
    text-decoration: none;
    color: #fff;
    height: 100%;
    overflow: hidden;
    width: -moz-fit-content;
    width: fit-content;
    max-width: 100%;
}
.menu-right-loggedin {
    margin-left: 10px;
    display: flex;
    align-items: center;
    gap: 0.4em;
    overflow-x: hidden;
    justify-content: flex-end;
}
.menu-right-account-link {
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    height: 100%;
    padding: 5px 0;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
}
.menu-right-account-img {
    height: 100%;
    width: auto;
}

.hamburger-icon-container {
    display:flex;
    align-items: center;
    height: 60%;
    cursor: pointer;
    border-radius: min(15%, 10px);
    box-sizing: border-box;
    padding: min(1%, 5px);
    background-color: transparent;
    transition: background-color 0.2s;
}
.hamburger-icon-container:hover {
    background-color: #8884;
}
.hamburger-icon-img {
    height: 100%;
}

@keyframes menu-list-dropdown {
    0% {
        height: 0;
    }
    100% {
        height: calc(100vh - var(--menuBarHeight));
    }
}

.hamburger-menu-list {
    position: absolute;
    top: var(--menuBarHeight);
    height: calc(100vh - var(--menuBarHeight));
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    align-items: center;
    background-color: rgba(16, 16, 17, 1);
    box-sizing: border-box;
    overflow: auto;
    z-index: 1005;
    border-top: 1px solid #888a;
    animation: menu-list-dropdown 0.3s;
    animation-fill-mode: both;
}

/* Scrollbar */
.hamburger-menu-list::-webkit-scrollbar {
    width: 10px;
}
.hamburger-menu-list::-webkit-scrollbar-track {
    background: #0000;
}
.hamburger-menu-list::-webkit-scrollbar-thumb {
    background: #8889;
}
.hamburger-menu-list::-webkit-scrollbar-thumb:hover {
    background: #aaaa;
}

.menuburger-link {
    width: 100%;
    padding: 8px 15px;
    margin: 0;
    text-decoration: none;
    color: #fff;
    background-color: #fff1;
    border-radius: 8px;
    font-size: 20px;
    font-weight: 600;
    box-sizing: border-box;
    box-shadow: -1px 1px 4px #8881;
    font-family: var(--paragraphFont);
}
.menuburger-link:hover {
    background-color: #8883;
    text-decoration: none;
}

.hml-mainitem-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    margin-bottom: min(5%, 15px);
    gap: 10px;
    box-sizing: border-box;
    align-items: center;
}
@media screen and (max-width: 700px) {
    .hml-mainitem-container {
        grid-template-rows: 1fr 1fr 1fr;
        grid-template-columns: 1fr;
    }
}
.hml-mainitem, .hml-mainitem-indev {
    gap: 10px;
    padding: min(8%, 25px) min(10%, 20px);
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    color: #000;
    font-family: var(--displayFont);
    font-weight: 700;
    font-size: 24px;
    transition: 0.2s;
}
.hml-mainitem {
    cursor: pointer;
}
.hml-mainitem:hover {
    transform: scale(1.01);
    box-shadow: -1px 1px 10px #fff4;
}

.hml-mainitem-title {
    display: flex;
    column-gap: min(5%, 10px);
    align-items: center;
    justify-content: center;
    background-color: #fff;
    padding: min(3%, 10px) min(10%, 20px);
    border-radius: 1000px;
    width: -moz-fit-content;
    width: fit-content;
    margin-bottom: min(5%, 10px);
}

/* These cards almost overflow on tiny screens */
@media screen and (max-width: 350px) {
    .hml-mainitem-title {
        font-size: 18px !important;
    }
    .hml-mainitem-img {
        height: 18px !important;
    }
    .hml-desc {
        font-size: 14px !important;
    }
}

.hml-mainitem-img {
    height: 24px;
}
.hml-desc {
    font-size: 16px;
    font-weight: 700;
    font-family: var(--paragraphFont);
    color: #000;
    margin: 0;
    padding: 0;
}

.hml-logout-button-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: min(5%, 10px) 0;
    padding: 0 min(10%, 20px);
    box-sizing: border-box;
}

.hml-green_aqua {
    background-image: linear-gradient(to right, rgb(70, 246, 152),rgb(51, 178, 221));
}

/* Use when projects are finished */
.hml-yellow_red {
    background-image: linear-gradient(to right, #dfdf9a, #e85353);
}
.hml-blue_magenta {
    background-image: linear-gradient(to right, rgb(42, 196, 248), rgb(255, 68, 243));
}

/* In development colors */
.hml-yellow_red-grayed {
    background-image: linear-gradient(to right, #dfdf9a80, #e8535380);
    background-color: #333;
}
.hml-blue_magenta-grayed {
    background-image: linear-gradient(to right, rgb(42, 196, 248, 0.5), rgb(255, 68, 243, 0.5));
    background-color: #333;
}`, "",{"version":3,"sources":["webpack://./src/styles/general/MenuBar.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,qCAAqC;IACrC,WAAW;IACX,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,iCAAiC;IACjC,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,oDAAoD;AACxD;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,2CAA2C;IAC3C,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;IACX,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,iDAAiD;AACjD;IACI,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,2BAA2B;IAC3B,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,UAAU;IACV,oBAAoB;IACpB,gBAAgB;IAChB,mCAAmC;IACnC,aAAa;AACjB;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,6BAA6B;IAC7B,sBAAsB;IACtB,qBAAqB;IACrB,6BAA6B;IAC7B,iCAAiC;AACrC;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,SAAS;IACb;IACA;QACI,0CAA0C;IAC9C;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,0CAA0C;IAC1C,OAAO;IACP,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,2BAA2B;IAC3B,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA,cAAc;AACd;IACI,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,qBAAqB;IACrB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,8BAA8B;IAC9B,iCAAiC;AACrC;AACA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,WAAW;IACX,4BAA4B;IAC5B,SAAS;IACT,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI;QACI,+BAA+B;QAC/B,0BAA0B;IAC9B;AACJ;AACA;IACI,SAAS;IACT,qCAAqC;IACrC,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,qCAAqC;IACrC,qBAAqB;IACrB,uBAAkB;IAAlB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA,gDAAgD;AAChD;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,gFAAgF;AACpF;;AAEA,mCAAmC;AACnC;IACI,6DAA6D;AACjE;AACA;IACI,iFAAiF;AACrF;;AAEA,0BAA0B;AAC1B;IACI,iEAAiE;IACjE,sBAAsB;AAC1B;AACA;IACI,2FAA2F;IAC3F,sBAAsB;AAC1B","sourcesContent":[".menu-bar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: rgba(16, 16, 17, 1);\n    color: #fff;\n    height: var(--menuBarHeight);\n    padding: 0 100px;\n    align-items: center;\n    box-sizing: border-box;\n    z-index: 100;\n}\n\n.noburger {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    column-gap: 10px;\n    padding: 0 50px;\n}\n\n.yesburger {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 min(5%, 30px);\n    font-size: 16px;\n}\n\n.menu-logo, .menu-logo-hamburger {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    color: #fff;\n    text-decoration: none;\n    font-family: var(--paragraphFont);\n    font-weight: 700;\n}\n.menu-logo {\n    font-size: 24px;\n}\n.menu-logo-hamburger {\n    font-size: calc(var(--menuBarHeight) * 0.4);\n}\n.menu-logo:hover, .menu-logo-hamburger:hover {\n    text-decoration: none;\n}\n\n.menu-logo-img, .menu-logo-img-hamburger {\n    height: 1.2em;\n    width: auto;\n    margin-right: 0.2em;\n    transition: 0.2s;\n}\n.menu-logo:hover .menu-logo-img, .menu-logo-hamburger:hover .menu-logo-img-hamburger {\n    filter: brightness(1.2) saturate(1.05) contrast(1.1);\n}\n\n.menu-logo-locdescriptor {\n    color: #fff;\n    font-size: 18px;\n    font-weight: 400;\n    border-left: 1px solid #fffb;\n    padding-left: 0.5em;\n    margin-left: 0.5em;\n}\n.menu-logo-locdescriptor-burger {\n    color: #fff;\n    font-size: calc(var(--menuBarHeight) * 0.3);\n    font-weight: 400;\n    border-left: 1px solid #fffb;\n    padding-left: 0.5em;\n    margin-left: 0.5em;\n}\n\n@media screen and (max-width: 350px) {\n    .menu-logo-vanishable-name {\n        display: none;\n    }\n    .menu-logo-img-hamburger{\n        margin-right: 0;\n    }\n    .menu-logo-locdescriptor-burger {\n        font-size: calc(var(--menuBarHeight) * 0.25);\n    }\n}\n\n.menu-middle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 40px;\n    flex-direction: row;\n}\n\n.menu-link {\n    font-size: 16px;\n    font-weight: 500;\n    font-family: var(--paragraphFont);\n    color: #fff;\n    text-decoration: none;\n    position: relative;\n}\n.menu-link:hover {\n    text-decoration: none;\n}\n\n.menu-link-indev {\n    font-size: 16px;\n    font-weight: 500;\n    font-family: var(--paragraphFont);\n    color: #fff8;\n    text-decoration: none;\n    position: relative;\n    cursor: default;\n}\n\n/* Box that appears on hovering over indev link */\n.menu-link-indev-hoverdesc {\n    position: absolute;\n    top: calc(100% + 5px);\n    left: 50%;\n    transform: translateX(-50%);\n    width: max-content;\n    background-color: #fff;\n    color: #000;\n    padding: 5px 10px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: var(--paragraphFont);\n    opacity: 0;\n    pointer-events: none;\n    transition: 0.2s;\n    box-shadow: -1px 1px 10px 4px #8888;\n    z-index: 1005;\n}\n.menu-link-indev:hover .menu-link-indev-hoverdesc {\n    opacity: 1;\n    pointer-events: all;\n}\n\n.menu-right {\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n    text-decoration: none;\n    color: #fff;\n    height: 100%;\n    overflow: hidden;\n    width: fit-content;\n    max-width: 100%;\n}\n.menu-right-loggedin {\n    margin-left: 10px;\n    display: flex;\n    align-items: center;\n    gap: 0.4em;\n    overflow-x: hidden;\n    justify-content: flex-end;\n}\n.menu-right-account-link {\n    color: #fff;\n    text-decoration: none;\n    font-size: 16px;\n    height: 100%;\n    padding: 5px 0;\n    width: 80%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    box-sizing: border-box;\n}\n.menu-right-account-img {\n    height: 100%;\n    width: auto;\n}\n\n.hamburger-icon-container {\n    display:flex;\n    align-items: center;\n    height: 60%;\n    cursor: pointer;\n    border-radius: min(15%, 10px);\n    box-sizing: border-box;\n    padding: min(1%, 5px);\n    background-color: transparent;\n    transition: background-color 0.2s;\n}\n.hamburger-icon-container:hover {\n    background-color: #8884;\n}\n.hamburger-icon-img {\n    height: 100%;\n}\n\n@keyframes menu-list-dropdown {\n    0% {\n        height: 0;\n    }\n    100% {\n        height: calc(100vh - var(--menuBarHeight));\n    }\n}\n\n.hamburger-menu-list {\n    position: absolute;\n    top: var(--menuBarHeight);\n    height: calc(100vh - var(--menuBarHeight));\n    left: 0;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px;\n    align-items: center;\n    background-color: rgba(16, 16, 17, 1);\n    box-sizing: border-box;\n    overflow: auto;\n    z-index: 1005;\n    border-top: 1px solid #888a;\n    animation: menu-list-dropdown 0.3s;\n    animation-fill-mode: both;\n}\n\n/* Scrollbar */\n.hamburger-menu-list::-webkit-scrollbar {\n    width: 10px;\n}\n.hamburger-menu-list::-webkit-scrollbar-track {\n    background: #0000;\n}\n.hamburger-menu-list::-webkit-scrollbar-thumb {\n    background: #8889;\n}\n.hamburger-menu-list::-webkit-scrollbar-thumb:hover {\n    background: #aaaa;\n}\n\n.menuburger-link {\n    width: 100%;\n    padding: 8px 15px;\n    margin: 0;\n    text-decoration: none;\n    color: #fff;\n    background-color: #fff1;\n    border-radius: 8px;\n    font-size: 20px;\n    font-weight: 600;\n    box-sizing: border-box;\n    box-shadow: -1px 1px 4px #8881;\n    font-family: var(--paragraphFont);\n}\n.menuburger-link:hover {\n    background-color: #8883;\n    text-decoration: none;\n}\n\n.hml-mainitem-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    width: 100%;\n    margin-bottom: min(5%, 15px);\n    gap: 10px;\n    box-sizing: border-box;\n    align-items: center;\n}\n@media screen and (max-width: 700px) {\n    .hml-mainitem-container {\n        grid-template-rows: 1fr 1fr 1fr;\n        grid-template-columns: 1fr;\n    }\n}\n.hml-mainitem, .hml-mainitem-indev {\n    gap: 10px;\n    padding: min(8%, 25px) min(10%, 20px);\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    color: #000;\n    font-family: var(--displayFont);\n    font-weight: 700;\n    font-size: 24px;\n    transition: 0.2s;\n}\n.hml-mainitem {\n    cursor: pointer;\n}\n.hml-mainitem:hover {\n    transform: scale(1.01);\n    box-shadow: -1px 1px 10px #fff4;\n}\n\n.hml-mainitem-title {\n    display: flex;\n    column-gap: min(5%, 10px);\n    align-items: center;\n    justify-content: center;\n    background-color: #fff;\n    padding: min(3%, 10px) min(10%, 20px);\n    border-radius: 1000px;\n    width: fit-content;\n    margin-bottom: min(5%, 10px);\n}\n\n/* These cards almost overflow on tiny screens */\n@media screen and (max-width: 350px) {\n    .hml-mainitem-title {\n        font-size: 18px !important;\n    }\n    .hml-mainitem-img {\n        height: 18px !important;\n    }\n    .hml-desc {\n        font-size: 14px !important;\n    }\n}\n\n.hml-mainitem-img {\n    height: 24px;\n}\n.hml-desc {\n    font-size: 16px;\n    font-weight: 700;\n    font-family: var(--paragraphFont);\n    color: #000;\n    margin: 0;\n    padding: 0;\n}\n\n.hml-logout-button-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    margin: min(5%, 10px) 0;\n    padding: 0 min(10%, 20px);\n    box-sizing: border-box;\n}\n\n.hml-green_aqua {\n    background-image: linear-gradient(to right, rgb(70, 246, 152),rgb(51, 178, 221));\n}\n\n/* Use when projects are finished */\n.hml-yellow_red {\n    background-image: linear-gradient(to right, #dfdf9a, #e85353);\n}\n.hml-blue_magenta {\n    background-image: linear-gradient(to right, rgb(42, 196, 248), rgb(255, 68, 243));\n}\n\n/* In development colors */\n.hml-yellow_red-grayed {\n    background-image: linear-gradient(to right, #dfdf9a80, #e8535380);\n    background-color: #333;\n}\n.hml-blue_magenta-grayed {\n    background-image: linear-gradient(to right, rgb(42, 196, 248, 0.5), rgb(255, 68, 243, 0.5));\n    background-color: #333;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
